import { create } from 'zustand';
import { connect, StreamClient, StreamFeed } from 'getstream';
import config from '../config.general';

interface StreamFeedState {
	feedClient: StreamClient | null;
	eventFeed: StreamFeed | null;
	feedName?: string;
	setFeedClientAndActivityFeed: (userKey: string, feedToken: string, feedName: string) => StreamClient;
}

const useStreamFeedStore = create<StreamFeedState>((set, get) => ({
	feedClient: null,
	eventFeed: null,
	feedName: null,
	setFeedClientAndActivityFeed: (userKey: string, feedToken: string, feedName: string) => {
		const currentState = get();

		// If we already have a feed, check if same feed name
		if (currentState.feedClient && currentState.feedName !== feedName) {
			const newFeed = currentState.feedClient.feed('event', feedName, feedToken);

			set({
				eventFeed: newFeed,
				feedName
			});

			return currentState.feedClient;
		}

		// Different feed name (e.g. event and community feed)
		const newClient = connect(config.streamApiKey, feedToken);
		const newFeed = newClient.feed('event', feedName, feedToken); // Should keep the same as BE to create event feed

		set({
			feedClient: newClient,
			eventFeed: newFeed,
			feedName
		});

		return newClient;
	}
}));

export default useStreamFeedStore;
